import { SellerFilter } from '@/components/SellerFilter/SellerFilter';
import { TableData } from '@/components/TableData/TableData';
import { TableSearch } from '@/components/TableSearch/TableSearch';
import { useGlobalContext } from '@/context/Global/GlobalContext';
import { ProductState } from '@/hooks/product/catalog/useGetProducts/productState';
import TableLayout from '@/layouts/TableLayout/TableLayout';
import { DashboardUserType } from '@/utils/enums';
import { Stack } from '@mui/material';
import { useProductsViewController } from './ProductsViewController';
import { itemGenerator } from './TableItem';

export function Products(props: { state?: ProductState }) {
  const { uiState, actions } = useProductsViewController(props.state);
  const { session } = useGlobalContext();

  return (
    <TableLayout
      header={
        <Stack direction={{ xs: 'column', md: 'row' }} spacing={'16px'}>
          {session?.type === DashboardUserType.ADMIN && (
            <SellerFilter
              sx={{ flex: { xs: undefined, md: '1 1 30%' } }}
              onFilterChanged={actions.onChangedSellerFilter}
            />
          )}

          <TableSearch
            sx={{ flex: { xs: undefined, md: '1 1 70%' } }}
            searchText={uiState.searchQuery}
            onChange={actions.onSearchChanged}
            isSearching={uiState.isSearching}
            hint="Buscar Producto"
          />
        </Stack>
      }
      isLoading={uiState.isLoading}
      body={
        <TableData
          columnHeaders={uiState.columnHeaders}
          items={uiState.products}
          rowItemGenerator={itemGenerator}
          paging={uiState.paging}
          roundedTop={true}
          onPageSelected={actions.onPageRequested}
        />
      }
    />
  );
}
